import React from 'react';

export const WaiverMilitaryRetiredPayDescription = () => (
  <va-card background>
    <h3 className="vads-u-margin--0">Waiver for military retired pay</h3>
    <p>
      Submission of this application constitutes a waiver of military retired
      pay in an amount equal to VA compensation awarded.
    </p>
    <p>
      If you are entitled to both benefits, your retired pay may be reduced by
      the amount of VA compensation awarded.
    </p>
    <p>
      Receipt of the full amount of military retired pay and VA compensation at
      the same time may result in overpayment, which may be subject to
      collection.
    </p>
    <p>
      In addition, the gross amount of any lump sum retirement payments made
      under the Blended Retirement System (BRS) must be recouped from VA
      compensation.
    </p>
    <p>
      If you qualify for full concurrent receipt of VA compensation and military
      retired pay, the waiver of retired pay or recoupment of any lump sum
      retirement payments will not apply.
    </p>
    <p>
      If you select that you don’t want to receive VA compensation pay, you will
      not receive VA compensation if granted. If you currently receive VA
      compensation AND you select that you don’t want to receive it, your VA
      compensation will be terminated if you are also eligible for military
      retired pay.
    </p>
    <p>
      <strong>Note:</strong> VA compensation is non-taxable. Therefore, VA
      compensation may be the greater benefit.
    </p>
  </va-card>
);
